<template>
  <v-container
    class="card_datos_empresa"
    style="height:100%; align-content:center;"
  >
    <div style="display:flex;align-items:center;">
      <h2 class="primary--text">
        DATOS DEL ADMINISTRADO
      </h2>
      <v-spacer />
      <v-btn
        icon
        @click="$emit('emitCerrarDatosUsuario')"
      >
        <v-icon
          color="primary"
          large
        >
          close
        </v-icon>
      </v-btn>
    </div>
    <article
      style="line-height: 2;"
      class="body-2"
    >
      <strong class="gray--text">RAZÓN SOCIAL:</strong>&nbsp;&nbsp;&nbsp;
      <span>{{ $store.state.datosSession.datosEmpresa.nombreEmpresa }}</span>
      <br>
      <strong class="gray--text">NÚMERO DE IDENTIFICACIÓN TRIBUTARIA:</strong>&nbsp;&nbsp;&nbsp;
      <span>{{ $store.state.datosSession.datosEmpresa.numeroDocumento }}</span>
      <br>
      <strong class="gray--text">DIRECCIÓN PARA FINES DE NOTIFICACIÓN:</strong>&nbsp;&nbsp;&nbsp;
      <span>{{ $store.state.datosSession.datosEmpresa.direccion != null ? $store.state.datosSession.datosEmpresa.direccion : '' }}</span>
      <br>
      <strong class="gray--text">TELÉFONO/CELULAR:</strong>&nbsp;&nbsp;&nbsp;
      <span>{{ ($store.state.datosSession.datosEmpresa.numeroTelefonoOficina != null ? $store.state.datosSession.datosEmpresa.numeroTelefonoOficina : '')+ ' - ' + ($store.state.datosSession.datosEmpresa.numeroTelefono != null ? $store.state.datosSession.datosEmpresa.numeroTelefono : '') }}
      </span>
      <br>
      <strong class="gray--text">CORREO ELECTRÓNICO DE NOTIFICACIÓN:</strong>&nbsp;&nbsp;&nbsp;
      <span>{{ $store.state.datosSession.datosEmpresa.correoCorporativo != null ? $store.state.datosSession.datosEmpresa.correoCorporativo : '' }}</span>
      &nbsp;
      <v-icon
        v-if="$store.state.Login.BitacoraTotalCorreo > 0"
        color="success"
        small
      >
        verified
      </v-icon>
      &nbsp;
      (
      <em style="text-decoration:underline;">
        <a @click="$router.push('/ActualizaCorreo'), $emit('emitCerrarDatosUsuario')">
          <v-icon
            small
            color="primary"
          >mail_outline</v-icon>cambiar correo
        </a>
      </em>
      )
      <v-divider class="my-3" />
      <span class="font-weight-bold gray--text">{{ $cadenas.TextoSubtituloRepresentantes() }} </span>&nbsp;&nbsp;&nbsp;
      <v-layout
        row
        wrap
        style="overflow-x:auto;"
      >
        <div style="width:100%; overflow:hidden; border: 1px solid #818080; border-radius:8px;">
          <table
            class="estiloTabla caption"
            style="min-width:400px; border-radius:8px;"
          >
            <tr class="oscuro white--text">
              <th>FECHA REGISTRO</th>
              <th>TIPO</th>
              <th>NOMBRE REPRESENTANTE LEGAL</th>
              <th>DOCUMENTO DE IDENTIDAD</th>
              <th>CORREO ELECTRÓNICO</th>
              <th>NUMERO TESTIMONIO</th>
              <th>FECHA EMISION</th>
              <th>ESTADO</th>
            </tr>
            <tr
              v-for="(item, index) in representantesLegales"
              :key="index"
            >
              <td>
                {{ item.fechaRegistro.substring(0,10) }}
              </td>
              <td>{{ item.tipoRepresentante || '-' }}</td>
              <td>{{ item.nombreCompleto }}</td>
              <td>
                {{ item.numeroDocumento }}
              </td>
              <td>{{ item.correo }}</td>
              <td>
                {{ item.numeroTestimonio }}
              </td>
              <td>
                {{ item.fechaEmision.substring(0,10) }}
              </td>
              <td>{{ item.estado }}</td>
            </tr>
          </table>
        </div>
      </v-layout>
      <CustomAlert
        type="warning"
        class="my-2"
      >
        <template v-slot:icon>
          !
        </template>
        <strong>IMPORTANTE:</strong> La lista de representantes legales y/o apoderados de su empresa se actualiza continuamente con el testimonio de poder legal adjunto en sus solicitudes de autorización, ampliación o modificación de promociones empresariales. Por lo tanto, es importante que adjunte el documento actualizado de testimonio de poder legal para asegurar la correcta inclusión en el registro.
      </CustomAlert>
      <CustomAlert
        type="warning"
        class="my-2"
      >
        <template v-slot:icon>
          !
        </template>
        <strong>IMPORTANTE:</strong> Es su responsabilidad, como administrado, comunicar de manera oportuna cualquier actualización de los datos. La AJ no se responsabiliza por posibles perjuicios que puedan derivarse de la omisión de esta actualización en el procesamiento de sus trámites.
      </CustomAlert>

      <!-- <strong>IMPORTANTE:</strong>&nbsp;Es de su pleno conocimiento la información registrada con la AJ y es de su responsabilidad como administrado solicitar la actualización de esta información si así corresponde. -->
    </article>
  </v-container>
</template>
<script>
import DialogProgress from "@/components/shared/DialogProgress";
import types from "@/store/types/Usuario";
import { mapActions } from "vuex";
import CustomAlert from "@/components/CustomAlert.vue";

export default {
  name: "DatosEmpresa",
  components: {
    DialogProgress,
    CustomAlert,
  },
  data() {
    return {
      representantesLegales: [],
    };
  },
  mounted() {
    if (!this.$store.state.sessionIciado) {
      this.$router.push("/Login");
    }
    this.CargarRepresentantesLegales();
  },
  methods: {
    // cerrarSession() {
    //   localStorage.setItem("token", "");
    //   this.$store.commit("vaciarDatosSession");
    //   this.$router.push("/Login");
    // },
    CargarMenusAdministracionNoCuenta() {
      // 1: EsAdministracion
      this.ObtenerListaMenus(1).then(respuesta => {
        const items = respuesta.data.filter(item => this.$menusAdministracionNoCuenta.includes(item.menuParametrizadoId));
        this.opcionesAdminNoCuenta = items;
      });
    },
    CargarRepresentantesLegales() {
      this.RepresentanteLegal(this.$store.state.datosSession.personaId).then((res) => {
        this.representantesLegales = res.data.result
      })
    },
    ...mapActions({
      RepresentanteLegal:types.actions.RepresentanteLegal,
    }),
    go(url) {
      this.$router.push(url);
    },
  },
  computed: {
    tamanioBoton() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 'small'
        case 'sm': return ''
        case 'md': return ''
        case 'lg': return 'large'
        case 'xl': return 'large'
      }
    }
  },
};
</script>
<style scoped>
.estiloTabla {
  border-collapse: collapse;
  width: 100%;
  border-spacing: 3px;
  line-height: 18px;
  background-color: white;
  overflow: hidden;
}
th {
  font-weight: bold;
  padding: 6px;
}
td {
  padding-block: 6px;
  border-top: 1px solid #818080;
  text-align: center;
}
table tr:hover {
    background-color: #f0f0f0; /* Cambia el color de fondo de la celda */
    cursor: pointer; /* Cambia el cursor al pasar sobre la celda */
}
/* phone */
@media (min-width: 0px) and (max-width: 460px) {
  .card_datos_empresa {
    width: 410px;
  }
}
</style>

